var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 17V8.81054L9.53022 10.5303C9.23732 10.8232 8.76256 10.8232 8.46967 10.5303C8.17678 10.2374 8.17678 9.76261 8.46967 9.46972L11.4697 6.46972L11.5263 6.41796C11.8209 6.17765 12.2556 6.19512 12.5302 6.46972L15.5302 9.46972C15.8231 9.76261 15.8231 10.2374 15.5302 10.5303C15.2373 10.8232 14.7626 10.8232 14.4697 10.5303L12.7499 8.81054V17C12.7499 17.4142 12.4142 17.75 11.9999 17.75C11.5857 17.75 11.2499 17.4142 11.2499 17Z",
    fill: "currentColor"
  })));
};
export default SvgArrowUp;